import * as colors from 'config/colors'
import { ROLE_OWNER, ROLE_GLOBAL_VIEWER } from 'constants/general.constants'

const owner_color = '#E67300'
const globalViewer_color = '#FCB314'
const viewer_color = '#888887'

const styles = {
  avatar: {
    width: ({ height }) => height || '6.5rem',
    display: 'flex',
    height: ({ height }) => height || '6.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    background: ({ role }) => {
      switch (role) {
        case ROLE_OWNER:
          return owner_color
        case ROLE_GLOBAL_VIEWER:
          return globalViewer_color
        default:
          return viewer_color
      }
    },
    borderRadius: '6rem'
  },
  title: {
    fontSize: ({ fontSize }) => fontSize || '2rem',
    color: colors.white
  }
}

export default styles
